import ApiConfig from "../config/Api.config";
import Data from "../data/Api.data";
import Aclaracion from "../interfaces/Aclaracion.interface";
import Request from "../interfaces/Request.interface";
import Response from "../interfaces/Response.interface";

const urlSinergia: string = `${Data.URLS.urlApiSinergia}/aclaracion`

const listar = async (fechaInicial: string, fechaFinal: string) => {
    const request: Request = {
        url: `${urlSinergia}/listar`,
        method: "POST",
        data: { fechaInicial, fechaFinal }
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;
};

const guardar = async (aclaracion: Aclaracion) => {
    const request: Request = {
        url: `${urlSinergia}/guardar`,
        method: "POST",
        data: { aclaracion }
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;
};

const eliminar = async (IdAclaracion: number) => {
    const request: Request = {
        url: `${urlSinergia}/eliminar/${IdAclaracion}`,
        method: "DELETE",
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;
};


const AclaracionService = {
    listar,
    eliminar,
    guardar,
}

export default AclaracionService;